import { columnTypes } from '@/services/Grid/ColumnTypes';
import DownloadFile from '@/components/Grid/Renderers/DownloadFile';
import RemoveIcon from '@/components/Grid/Renderers/RemoveIcon';
import ClientFile from '@/services/Client/ClientFile';
import Vue from 'vue';
import Icon from '@/components/Grid/Renderers/Icon';
import Badge from '@/components/Grid/Renderers/Badge';

export const clientFileGridColumnTypes = columnTypes;

export const clientFileDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const clientFileGridColumns = [
  {
    headerName: 'ID',
    field: 'fileId',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Name',
    field: 'originalFilename',
    minWidth: 300,
  },
  {
    headerName: 'Description',
    field: 'description',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Date Uploaded',
    field: 'createdDate',
    type: 'dateTimeColumn',
    width: 170,
    minWidth: 170,
  },
  {
    headerName: 'Uploaded By',
    field: 'createdBy',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Direction',
    field: '',
    width: 150,
    minWidth: 150,
    valueGetter: ({ data }) => (data.userType === 'clientUser'
      ? 'Sent'
      : 'Received'
    ),
  },
  {
    headerName: 'Download',
    field: '',
    width: 125,
    minWidth: 125,
    cellRendererFramework: DownloadFile,
  },
  {
    headerName: 'Delete',
    field: '',
    width: 125,
    minWidth: 125,
    cellRendererFramework: RemoveIcon,
    cellRendererParams(params) {
      const { api, data } = params;
      const { clientId, fileId, originalFilename } = data;
      const onRemoveClick = async () => {
        try {
          api.showLoadingOverlay();
          await ClientFile.delete(clientId, fileId);
          Vue.notify({
            title: 'Success',
            text: 'File has been deleted',
            type: 'success',
          });
          api.updateRowData({ remove: [data] });
        } catch (e) {
          Vue.notify({
            title: 'Error',
            text: 'Sorry, something has gone wrong. Please try again later',
            type: 'error',
          });
        } finally {
          api.hideOverlay();
        }
      };

      return {
        modalText: `Are you sure you wish to delete ${originalFilename}?`,
        showConfirmModal: true,
        onRemoveClick: async () => onRemoveClick(),
      };
    },
  },
];
